import { TurnstileApi } from '../types/turnstile.types';

export const TURNSTILE_HEADER = 'CF-Turnstile-Response';

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

const SCRIPT_ID = 'cf-turnstile-script';
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const ONLOAD_CALLBACK = 'onTruhuTurnstileLoad';

let scriptPromise: Promise<TurnstileApi> | null = null;

export const loadTurnstileScript = (): Promise<TurnstileApi> => {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise<TurnstileApi>((resolve, reject) => {
      const settle = () => {
        if (window.turnstile) {
          resolve(window.turnstile);
        } else {
          reject(new Error('Turnstile script loaded, but the API is not available'));
        }
      };

      window.onTruhuTurnstileLoad = settle;

      if (document.getElementById(SCRIPT_ID)) {
        return;
      }

      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = `${SCRIPT_SRC}&onload=${ONLOAD_CALLBACK}`;
      script.async = true;
      script.defer = true;
      script.addEventListener('error', () => {
        scriptPromise = null;
        script.remove();
        reject(new Error('Turnstile script could not be loaded'));
      });

      document.head.appendChild(script);
    });
  }

  return scriptPromise;
};
